import { render, staticRenderFns } from "./AdditionalDataClient.vue?vue&type=template&id=1f4ab0e3&scoped=true"
import script from "./AdditionalDataClient.vue?vue&type=script&lang=js"
export * from "./AdditionalDataClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ab0e3",
  null
  
)

export default component.exports